const ru = {
  'map-box-url': 'mapbox://styles/egotkacheco/ckkxyhkvw6hih17p5ruy022jv',
  'sign-in': 'Войдите в систему',
  'login-placeholder': 'Логин',
  'login-required': 'Введите логин',
  'password-placeholder': 'Пароль',
  'password-required': 'Введите пароль',
  next: 'Далее',
  'forgot-password-q': 'Забыли пароль?',
  'error-user-not-found': 'Пользователь не найден',
  'forgot-password': 'Забыли пароль',
  'forgot-password-successfully-sended': 'Письмо успешно отправлено.',
  'restore-password': 'Восстановить',

  'navigation-map': 'Карта',
  'navigation-analytic': 'Аналитика',
  'navigation-users': 'Пользователи',

  search: 'Поиск',
  add: 'Добавить',
  edit: 'Редактировать',
  remove: 'Удалить',
  cancel: 'Отменить',
  save: 'Сохранить',
  status: 'Статус',
  name: 'Имя',
  surname: 'Фамилия',
  patronymic: 'Отчество',
  role: 'Роль',
  email: 'Почта',
  invited: 'Приглашен',
  accepted: 'Подтвержден',
  user: 'пользователя',
  admin: 'Администратор',
  regioncoordinator: 'Руководитель региона',
  coordinator: 'Координатор',

  timetable: 'График выполнения',
  table: 'Таблица',
  exceptions: 'Управление исключениями',
  analytic: 'Аналитика',
  'evaluations-completed': 'Выполнено оценок',
  plan: 'План',
  completed: 'Выполнено',
  'appointment-quotas': 'Назначено квоты с учетом выполнения',
  assigned: 'Поручено',
  'rcv-applics': 'Не назначено',
  'yesterday-percent': 'Как сработали в % за вчера',
  'yesterday-completed': 'Выполнено за вчера',
  'plan-fulffillment': 'Выполнение плана по дням',
  assistants: 'Ассистенты',
  'completed-surveys': 'Выполнено оценок',
  managers: 'Менеджеры',
  'not-available': 'Отсутствуют',
  fact: 'факт',
  prediction: 'прогноз',
  export: 'Експорт',
  regions: 'Области',
  projects: 'Проекты',
  'region/project/city': 'Область/Проект/Город',
  'project/region/city': 'Проект/Область/Город',
  'shopper-assigned': 'Поручено на тайного покупателя',
  total: 'Общий итог',
  'not-assigned': 'Не назначено',
  project: 'Проект',
  'visits-limit': 'Лимит визитов',
  rotation: 'Ротация',
  'start/end-project': 'Старт/Финиш проекта',
  start: 'Старт',
  end: 'Финиш',
  'forbidden-days': 'Запрещенные дни',
  step: 'Шаг',
  comment: 'Комментарий',
  limit: 'Лимит',
  'not-selected': 'Не выбрано',
  'month-1': '1 месяц',
  'month-2': '2 месяца',
  'month-3': '3 месяца',
  'month-4': '4 месяца',
  'month-5': '5 месяцев',
  'month-6': '6 месяцев',

  Выполнено: 'Выполнено',
  'В процессе': 'В процессе',
  Заявка: 'Заявка',
  'Не назначено': 'Не назначено',
  Отклонено: 'Отклонено',

  'map-search': 'Поиск на карте',
  'address-search': 'Поиск адреса',
  address: 'Адрес',
  locations: 'Локации',
  shoppers: 'Шопперы',
  my: 'Мои',
  all: 'Все',
  reset: 'Сбросить',
  apply: 'Применить',
  back: 'Назад',
  'visits-total': 'Visits total:',
  age: 'Возраст',
  sex: 'Пол',
  male: 'Мужской',
  female: 'Женский',
  experiance: 'Опыт работы',
  'visits-number': 'Количество визитов',
  'region/country': 'Регион/Страна',
  'car-available': 'Наличие авто',
  'shopper-out': 'Выездной шоппер',
  'auto-model': 'Марка автомобиля',
  'shoppers-total': 'Всего шопперов:',

  'empty-basket': 'Добавьте магазины в список',
  'select-shopper': 'Подобрать шоппера',
  find: 'Найти',

  rate: 'Стоимость',
  'shopper-login': 'Логин шоппера',
  'visit-scenario': 'Сценарий визита',
  'visit-summary': 'Краткая информация о визите',
  info: 'Инфо',
  history: 'История',
  'visit-calendar': 'Календарь посещений',
  more: 'Подробнее',
  'visit-created': 'Создание',
  'visit-location': '№ локации',

  'month.': 'мес',
  'show-more': 'Показать еще',

  'shopper-visits_min': 'Посещений',
  'shopper-visits': 'Посещений (кол-во выполненных визитов)',
  'shopper-registration_min': 'Регистрация',
  'shopper-registration': 'Регистрация (дата регистрации)',
  'shopper-last-login': 'Последний логин (последний вход в систему)',
  login: 'Login',

  'shopper-auto': 'Авто',
  'shopper-job': 'Место работы',
  'shopper-assigned-visits': 'Назначенные визиты',

  'assign-visit': 'Оформить визит',

  'select-visits': 'Подбор визитов',
  'shopper-fact-address': 'Фактический адрес шоппера',
  'with-rotation': 'С учетом ротации',
  'with-step': 'С учетом шага',
  'search-radius': 'Радиус поиска',
  km: 'км',

  'select-shoppers': 'Подбор шоперов',
  'visit-assign': 'Оформление визита ',
  'visit-date': 'Дата посещения',
  finish: 'Завершить',

  '1-mos': '1 месяц',
  '1-3-mos': '1-3 месяца',
  '3-6-mos': '3-6 месяцев',
  '6-mos': '6 месяцев - 1 год',
  'more-1-year': 'больше 1 года',

  'less-10': 'до 10',
  'more-500': 'больше 500',
}
export default ru
